import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownViewerProps {
  content: string;
}

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ content }) => {
  // 如果内容为空，返回空组件
  if (!content) {
    return null;
  }

  return (
    <div className="markdown-viewer">
      <ReactMarkdown 
        remarkPlugins={[remarkGfm]} 
        components={{
          // 为不同元素定义类名和样式
          p: ({node, children, ...props}) => <p className="markdown-paragraph" {...props}>{children}</p>,
          h1: ({node, children, ...props}) => <h1 className="markdown-heading" {...props}>{children}</h1>,
          h2: ({node, children, ...props}) => <h2 className="markdown-heading" {...props}>{children}</h2>,
          ul: ({node, children, ...props}) => <ul className="markdown-list" {...props}>{children}</ul>,
          li: ({node, children, ...props}) => <li className="markdown-list-item" {...props}>{children}</li>,
          // 可根据需要添加更多元素样式
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownViewer; 